// extracted by mini-css-extract-plugin
module.exports = {"grid":"blog-module--grid--3M20Q","row":"blog-module--row--2OJjK"};